<template>
  <v-container fluid text-xs-center style="padding:0px">
    <v-layout row wrap>
      <v-flex xs8 style="padding-right:20px" align-center align-content-center>
        <div
          style="min-width:300px;width:400px;margin:0 auto;margin-top:15px;height:50px"
          class="headline"
        >
          Gas
        </div>
        <v-autocomplete
          v-model="operator"
          :items="provider"
          label="Select Operator"
          style="min-width:300px;width:400px;margin:0 auto;height:60px"
          solo
          chips
          item-text="name"
          item-value="name"
        >
          <template slot="selection" slot-scope="data">
            <v-chip :selected="data.selected" close class="chip--select-multi">
              <v-avatar>
                <img :src="data.item.avatar" @error="errorimg" />
              </v-avatar>
              {{ data.item.name }}
            </v-chip>
          </template>
          <template slot="item" slot-scope="data">
            <template>
              <v-list-tile-avatar>
                <img :src="data.item.avatar" @error="errorimg" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
        <v-autocomplete
          style="min-width:300px;width:400px;margin:0 auto;height:53px"
          v-model="circle"
          :items="states"
          label="Select Circle"
          solo
        />
        <v-text-field
          type="text"
          v-model="billno"
          style="min-width:300px;width:400px;margin:0 auto;height:53px"
          label="Enter Bill Pay No"
          solo
        />
        <div class="positionbtn">
          <v-btn
            @click="fetchbill()"
            depressed
            round
            small
            color="primary"
            style="float:right;margin-bottom:10px;width:180px"
            >Fetch Bill Details</v-btn
          >
        </div>
        <v-text-field
          type="number"
          style="min-width:300px;width:400px;margin:0 auto;height:53px"
          label="Enter Mobile Number"
          v-model="rechargernumber"
          solo
        />
        <v-text-field
          type="text"
          style="min-width:300px;width:400px;margin:0 auto;height:53px"
          label="Enter Name"
          v-model="rechargername"
          solo
        />
        <v-text-field
          type="number"
          v-model="rechargeramount"
          style="min-width:300px;width:400px;margin:0 auto;height:60px"
          label="Enter Amount"
          solo
        />
        <div style="width:100%;float:left">
          <v-btn
            color="primary"
            style="min-width:300px;width:400px;margin:0 auto;"
            @click="submit"
            >Submit</v-btn
          >
        </div>
      </v-flex>
      <v-flex xs4>
        <v-card style="margin-top:15px;">
          <v-list subheader style="padding-bottom:0px">
            <v-subheader>Commisions</v-subheader>
            <v-divider></v-divider>
            <div v-for="(item, i) in commisions" :key="i">
              <v-list-tile @click="">
                <v-list-tile-avatar>
                  <img :src="item.img" @error="errorcom" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  {{ item.offer }}
                </v-list-tile-action>
              </v-list-tile>
              <v-divider></v-divider>
            </div>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="billmodel" width="400">
      <v-card>
        <v-card-title style="height:40px">
          <span class="body-2">Bill Details</span>
        </v-card-title>
        <v-card-text style="padding-top:0px">
          <v-layout row wrap v-for="(item, key) in summary" :key="key + item">
            <v-flex xs6>
              <v-card-text class="px-0">{{ key }}</v-card-text>
            </v-flex>
            <v-flex xs6>
              <v-card-text class="px-0">{{ item }}</v-card-text>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      commisions: [],
      operator: "",
      circle: "",
      provider: [],
      rechargernumber: "",
      rechargeramount: "",
      billmodel: false,
      summary: [],
      billno: "",
      rechargername: "",
      states: [
        "Andaman and Nicobar Islands",
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chandigarh",
        "Chhattisgarh",
        "Dadra and Nagar Haveli",
        "Daman and Diu",
        "Delhi",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Lakshadweep",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Orissa",
        "Pondicherry",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Tripura",
        "Uttaranchal",
        "Uttar Pradesh",
        "West Bengal",
      ],
    };
  },
  methods: {
    setarray(name, offer, img) {
      let array = { name: name, offer: offer, img: img };
      return array;
    },
    errorimg(e) {
      e.target.src = require("../assets/logo_single.png");
    },
    showprovider() {
      let vm = this;
      vm.provider = [];
      let docs = vm.gprovider;
      for (let i = 0; i < docs.length; i++) {
        let img = docs[i].Circle_Image;
        if (img == "*") {
          img = require("../assets/logo_single.png");
        } else {
          img = vm.$store.getters.src + img;
        }
        console.log(img);
        if (docs[i].Service != "Multi") {
          vm.provider.push({
            name: docs[i].Service,
            avatar: img,
          });
        }
      }
    },
    showcommisions() {
      let vm = this;
      vm.commisions = [];
      let docs = vm.commisionlist;
      for (let i = 0; i < docs.length; i++) {
        if (docs[i].ServiceType == "BP") {
          let doc = docs[i];
          let img = docs[i].Circle_Img_Path;
          if (img == "*") {
            img = require("../assets/logo_single.png");
          } else {
            img = vm.$store.getters.src + img;
          }
          vm.commisions.push(vm.setarray(doc.Service, doc.Offer + "%", img));
        }
      }
    },
    errorcom(e) {
      e.target.src = require("../assets/discount.svg");
    },
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type,
      });
    },
    submit() {
      let vm = this;
      if (vm.user == null || !vm.user.phone)
        return vm.notification("error", "Login Required!");
      if (vm.operator == "")
        return vm.notification("error", "Operator Required");
      if (vm.circle == "") return vm.notification("error", "Circle Required");
      if (vm.billno == "") return vm.notification("error", "Bill No Required");
      if (vm.rechargernumber == "")
        return vm.notification("error", "Mobile Number Required");
      if (vm.rechargernumber.length != 10)
        return vm.notification("error", "Valid Phone Number Required");
      if (vm.rechargername == "")
        return vm.notification("error", "Name Required");
      if (vm.rechargeramount == "")
        return vm.notification("error", "Amount Required");
      let number =
        vm.billno + "-NA-NA-" + vm.rechargername + "-" + vm.rechargernumber;
      let doc = {
        MobileNo: vm.user.phone,
        Password: vm.user.password,
        RechargeType: "bp",
        ServiceName: vm.operator,
        Amount: vm.rechargeramount,
        RechargeNumber: number,
        TransId: "NA",
        Circle: vm.circle,
        AuthKey: vm.user.authkey,
        Source: "json",
      };
      vm.$parent.dialog = true;
      vm.$store
        .dispatch("axiospost", {
          url: "MakeRecharge",
          data: doc,
        })
        .then(function(res) {
          vm.$parent.dialog = false;
          vm.$store.dispatch("getbalance");
          if (res.data.Status == null) vm.notification("error", "Try Agian!");
          if (res.data.Status == "False") {
            if (res.data.Message == "Not Authorised.") {
              window.localStorage.removeItem("user");
              vm.$store.dispatch("getuser");
              vm.$router.push("/account");
              return vm.notification("error", res.data.Message);
            }
            return vm.notification("error", res.data.Message);
          }
          if (res.data.Status == "True") {
            vm.operator = "";
            vm.circle = "";
            vm.rechargernumber = "";
            vm.rechargeramount = "";
            vm.billno = "";
            vm.rechargername = "";
            return vm.notification("success", res.data.Message);
          }
          return vm.notification("error", res.data.Message);
        })
        .catch(function(error) {
          console.log(error);
          vm.notification("error", error);
          vm.$parent.dialog = false;
        });
    },
    fetchbill() {
      let vm = this;
      if (vm.operator == "")
        return vm.notification("error", "Operator Required");
      if (vm.billno == "") return vm.notification("error", "Bill No Required");
      let doc = {
        ServiceType: "gb",
        ServiceName: vm.operator,
        AccountNumber: vm.billno,
        Option1: "NA",
        Option2: "NA",
      };
      vm.$parent.dialog = true;
      vm.$store
        .dispatch("fetchbill", {
          data: doc,
        })
        .then(function(res) {
          vm.$parent.dialog = false;
          vm.summary = [];
          vm.$store
            .dispatch("showdetails", {
              data: res.data,
            })
            .then(function(doc) {
              vm.$parent.dialog = false;
              vm.summary = doc;
              vm.billmodel = true;
            })
            .catch(function(error) {
              vm.$parent.dialog = false;
              vm.notification("error", error);
            });

          //vm.showdetails(res.data)
        })
        .catch(function(error) {
          vm.$parent.dialog = false;
          vm.notification("error", error.message);
        });
    },
  },
  computed: {
    gprovider() {
      return this.$store.getters.gprovider;
    },
    commisionlist() {
      return this.$store.getters.commissions;
    },
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    gprovider(docs) {
      let vm = this;
      vm.showprovider();
    },
    commisionlist(docs) {
      let vm = this;
      vm.showcommisions();
    },
  },
  mounted() {
    let vm = this;
    vm.showcommisions();
    console.log("welcome");
    vm.showprovider();
  },
};
</script>

<style scoped>
.v-input--radio-group__input {
  width: 400px;
}

.positionbtn {
  min-width: 300px;
  width: 400px;
  margin: 0 auto;
  height: 53px;
}
</style>
